<template>
  <div class="lang-switcher">
    <m4-button
      v-for="(lang, i) in langs"
      :key="i"
      tag="a"
      :title="lang.selected ? null : langTitle + ' ' + lang.title"
      :href="lang.selected ? null : lang.link"
      variant="default-text"
      :class="
        'lang-switcher__btn' +
        (lang.selected ? '' : ' lang-switcher__btn--unselected') +
        (dark ? ' lang-switcher__btn--dark' : '')
      "
    >
      {{ lang.title }}
    </m4-button>
  </div>
</template>

<script>
export default {
  name: "M4LangSwitcher",
  props: {
    langs: {
      type: Array,
      default() {
        return [];
      }
    },
    langTitle: {
      type: String,
      default() {
        return "Switch to";
      }
    },
    dark: Boolean
  }
};
</script>
